import main from "../images/plan/main.webp";
import { useTranslation } from 'react-i18next';

function PlanTrip() {
  const { t } = useTranslation();

  return (
    <>
      <section className="plan-section" style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${main})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center"
      }}>
        <div className="container">
          <div className="plan-container" style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "2rem"
          }}>
            <div className="plan-content" style={{
              color: "white",
              flex: "1"
            }}>
              <h1 style={{
                fontSize: "4rem",
                marginBottom: "1rem"
              }}>
                {t('planTrip.title')}
              </h1>

              <p style={{
                fontSize: "2rem",
                marginBottom: "2rem"
              }}>
                {t('planTrip.description')}
              </p>

              <button style={{
                padding: "1.5rem 3rem",
                fontSize: "1.4rem",
                backgroundColor: "#ff4d30",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "1rem"
              }}>
                {t('planTrip.button')}
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>

            <div className="plan-image" style={{
              flex: "0.7",
              display: "flex",
              justifyContent: "center"
            }}>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PlanTrip;
